import * as z from "zod/v4";

export const markAsReadyForPickup = {
  name: "markAsReadyForPickup" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    userId: z.string(),
  }),
  output: z.object({ batchId: z.string(), batchNumber: z.string() }),
};
